/** 시군구까지 좁혔을 때 기본 축제 검색 반경 (미터) */
export const DEFAULT_FESTIVAL_RADIUS_METER = 30_000;

/**
 * 지역(시군구)을 좁히지 않은 경우(전국·시도 전체)에 쓰는 반경 (미터).
 * v2 축제 검색은 radius가 필수라, 단일 중심점에서 한국 전체를 덮는 600km로 사실상 무제한 처리한다.
 * 백엔드 radius 상한을 600km로 상향한 뒤에만 동작한다.
 */
export const NATIONWIDE_FESTIVAL_RADIUS_METER = 600_000;
